export default "__VITE_ASSET__CuKXdIRh__"